import Drawable from '../entities/Drawable.js';
import OptionsBox from './OptionsBox.js';

export default class MartOptionsMenu extends Drawable {
    constructor({ stateMachine }) {
        super();
        this.stateMachine = stateMachine;
        this.visible = false;
        this.currentOption = 0;

        this.martOptionsMenuBox = new OptionsBox({
            position: { x: 0, y: 0 },
            options: ['BUY', 'SELL', 'SEE YA!'],
            selectedOption: 0,
            visible: false,
        });
    }

    draw() {
        this.martOptionsMenuBox.visible = this.visible;
        if (!this.visible) {
            return;
        }
        this.martOptionsMenuBox.selectedOption = this.currentOption;
        this.martOptionsMenuBox.draw();
    }
}
